import React, { useEffect, useState } from 'react';
import { ShoppingCart, Phone, Mail, MapPin, Menu, X } from 'lucide-react';
import PromotionsPage from './PromotionsPage';
import { usePromoCart } from './promo/promoCart';
import { openCookieSettings } from './CookieBanner';
import { AppErrorBoundary } from './AppErrorBoundary';

// Page Promotions autonome et légère (arrivées depuis les pubs) : le reste du site se charge à la navigation
const go = (page) => { window.location.href = page === 'home' ? '/' : `/?page=${page}`; };
const NAV = [['home', 'Accueil'], ['promotions', 'Promotions'], ['boutique', 'Boutique'], ['catalogues', 'Catalogues'], ['a-propos', 'À propos']];

const boutiqueCount = () => {
  try { return (JSON.parse(localStorage.getItem('ledzone_cart') || '[]') || []).reduce((n, i) => n + (i.quantity || 1), 0); } catch (e) { return 0; }
};

const LightHeader = () => {
  const promo = usePromoCart();
  const [open, setOpen] = useState(false);
  const [shop, setShop] = useState(0);
  useEffect(() => { setShop(boutiqueCount()); }, []);
  const count = promo.count + shop;
  return (
    <header className="sticky top-0 z-40 bg-black/90 backdrop-blur border-b border-zinc-800" data-testid="light-header">
      <div className="max-w-7xl mx-auto px-4 h-16 flex items-center justify-between gap-4">
        <button className="md:hidden text-zinc-300" onClick={() => setOpen(!open)} aria-label="Menu" data-testid="light-menu-toggle">{open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}</button>
        <a href="/" className="shrink-0" data-testid="light-logo"><img src="/logos/logo-ledzone-header.png" alt="LED ZONE" className="h-5 w-auto" width="156" height="20" /></a>
        <nav className="hidden md:flex items-center gap-8 text-sm">
          {NAV.map(([k, l]) => (
            <button key={k} onClick={() => k !== 'promotions' && go(k)} className={k === 'promotions' ? 'font-bold text-red-400' : 'text-zinc-400 hover:text-white'} data-testid={`light-nav-${k}`}>{l}</button>
          ))}
        </nav>
        <a href="/?page=panier" className="relative text-zinc-300 hover:text-white p-2" aria-label="Panier" data-testid="light-cart">
          <ShoppingCart className="w-5 h-5" />
          {count > 0 && <span className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-amber-500 text-black text-[11px] font-bold flex items-center justify-center" data-testid="light-cart-count">{count}</span>}
        </a>
      </div>
      {open && (
        <nav className="md:hidden border-t border-zinc-800 px-4 py-2" data-testid="light-mobile-menu">
          {NAV.map(([k, l]) => (
            <button key={k} onClick={() => (k === 'promotions' ? setOpen(false) : go(k))} className={`block w-full text-left py-3 ${k === 'promotions' ? 'text-red-400 font-semibold' : 'text-zinc-300'}`} data-testid={`light-mobile-nav-${k}`}>{l}</button>
          ))}
        </nav>
      )}
    </header>
  );
};

const LightFooter = () => (
  <footer className="mt-24 border-t border-zinc-800 bg-black text-sm" data-testid="light-footer">
    <div className="max-w-7xl mx-auto px-4 py-12 grid gap-8 sm:grid-cols-3">
      <div className="space-y-3">
        <img src="/logos/logo-ledzone-header.png" alt="LED ZONE" className="h-5 w-auto" loading="lazy" />
        <p className="text-zinc-500">Spécialiste suisse de l'éclairage LED professionnel.</p>
      </div>
      <ul className="space-y-2 text-zinc-400">
        <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-zinc-600" />032 730 44 45</li>
        <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-zinc-600" />info@ledzone.ch</li>
        <li className="flex items-center gap-2"><MapPin className="w-4 h-4 text-zinc-600" />Neuchâtel, Suisse</li>
      </ul>
      <ul className="space-y-2">
        <li><a href="/?page=cgv" className="text-zinc-400 hover:text-white">Conditions générales de vente</a></li>
        <li><a href="/?page=confidentialite" className="text-zinc-400 hover:text-white">Politique de confidentialité</a></li>
        <li><a href="/?page=mentions-legales" className="text-zinc-400 hover:text-white">Mentions légales</a></li>
        <li><button onClick={openCookieSettings} className="text-zinc-400 hover:text-white" data-testid="light-footer-cookies">Cookies</button></li>
      </ul>
    </div>
    <p className="text-center text-xs text-zinc-600 pb-8">© {new Date().getFullYear()} LED ZONE. Tous droits réservés.</p>
  </footer>
);

export default function PromoApp() {
  return (
    <div className="min-h-screen bg-zinc-950 text-white">
      <LightHeader />
      <AppErrorBoundary message="Les offres n'ont pas pu être chargées">
        <PromotionsPage onNavigate={go} onProductClick={(pid) => { window.location.href = `/produit/${pid}`; }} />
      </AppErrorBoundary>
      <LightFooter />
    </div>
  );
}
